import './welcome-screen.scss';

import {
    NavLink, Redirect, Route, withRouter,
} from 'react-router-dom';
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import RouteMapping from '../../configmodules/routing/routeMapping';
import UserAccordion from '../users-settings/user';
import { connect } from 'react-redux';
import { withAuth } from '@okta/okta-react';

const Welcome = ({
    location, history, childRoutes,
}) => {

    useEffect(() => {

        const currenturl = location.pathname.split('/');
        const adminurl = currenturl[2];
        const defaulturl = childRoutes[0] && childRoutes[0].id.replace(/ +/g, '');
        if (adminurl === undefined && defaulturl !== undefined) {

            history.push(`/welcome/${defaulturl}`);

        }

    }, [childRoutes, history, location.pathname]);

    const linkList = childRoutes.map((product) => (
        <>
            <li key={product.id}>
                {product.accordion ? <UserAccordion title={product.title} childRoutes={product.childRoute} /> : <NavLink activeClassName="selected" to={product.path}><FormattedMessage id={product.name} /></NavLink>}
            </li>

        </>
    ));

    return (
        <section className="welcome-screen">
            <aside className="welcome-screen-navigation">
                <ul className="welcome-screen-navigation-list">
                    <li>
                        {linkList}
                    </li>
                </ul>
            </aside>
            <RouteMapping routes={childRoutes} />
            <Route render={() => <Redirect to="/welcome/notifications" />} />
        </section>
    );

};

Welcome.propTypes = {
    location: PropTypes.object.isRequired,
    history: PropTypes.any.isRequired,
    childRoutes: PropTypes.object,
};

export default connect(
)(withAuth(withRouter(Welcome)));
